<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    modal-append-to-body
    append-to-body
    destroy-on-close
    width="900px"
    :close-on-click-modal="false"
    @closed="handelClosed"
  >
    <div class="dialog-content" v-loading="getLoading">
      <div>
        <el-form :model="form" label-width="120px" class="form" ref="formRef" :rules="rules">
          <el-form-item label="单位选择" prop="floatUnit">
            <el-radio-group v-model="form.floatUnit" @change="changeRadio">
              <el-radio :label="1">%</el-radio>
<!--              <el-radio :label="0">元</el-radio>-->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="城市选择" prop="cityIdList">
            <el-cascader
              v-model="form.cityIdList"
              ref="cascaderRef"
              style="margin-right: 10px;width: 300px;"
              placeholder="请选择城市"
              :options="cityListOptions"
              :props="{ multiple: true,emitPath:false }"
              collapse-tags
              filterable
              @change="handleChange($event)"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="市场价浮动价" prop="initPriceFloat">
            <el-input
              v-model="form.initPriceFloat"
              placeholder="请输入"
              style="width: 200px"
              @input="handleInput($event,'initPriceFloat')"
            >
              <template slot="append">{{objectTypeText}}
              </template>
            </el-input>
            <span style="font-size: 12px;color: #999;margin-left: 10px;">注意：在守兔的市场价基础上，进行加价或减价，填写时值在-50 ~ +50这个区间</span>
          </el-form-item>
          <el-form-item label="特惠购票浮动价" prop="discountPriceFloat">
            <el-input
              v-model="form.discountPriceFloat"
              placeholder="请输入"
              style="width: 200px"
              @input="handleInput($event,'discountPriceFloat')"
            >
              <template slot="append">{{objectTypeText}}
              </template>
            </el-input>
            <span style="font-size: 12px;color: #999;margin-left: 10px;">注意：在守兔的特惠购票价格基础上,进行加价或减价，填写时值在-50 ~ +50这个区间</span>
          </el-form-item>
          <el-form-item label="快速购票浮动价" prop="fastPriceFloat">
            <el-input
              v-model="form.fastPriceFloat"
              placeholder="请输入"
              style="width: 200px"
              @input="handleInput($event,'fastPriceFloat')"
            >
              <template slot="append">{{objectTypeText}}
              </template>
            </el-input>
            <span style="font-size: 12px;color: #999;margin-left: 10px;">注意：在守兔的快速购票价格基础上,进行加价或减价，填写时值在-50 ~ +50这个区间</span>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-left: 120px;padding-top:30px;">
        <el-button type="warning" @click="submitForm" :loading="loading">确认</el-button>
        <el-button type="warning" plain @click="handelClosed">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import {deepClone} from '@/utils/tool.js'
let reg = /^(?:[-]?(?:(?:[0-9]|[1-4]\d)(?:\.\d{1,2})?|50(?:\.0{1,2})?))$/
export default {
  name: "priceFloatPop",
  data() {
    return {
      rules: {
        floatUnit: [{ required: true, message: '请选择适用对象', trigger: 'blur' }],
        cityIdList: [{ required: true, message: '请选择城市', trigger: 'blur' }],
        initPriceFloat: [{ required: true, message: '请输入市场价浮动价', trigger: 'blur' },{pattern:reg,message:'请输入-50~50，最多支持输入两位小数',trigger:'blur'}],
        discountPriceFloat: [{ required: true, message: '请输入特惠购票浮动价', trigger: 'blur' },{pattern:reg,message:'请输入-50~50，最多支持输入两位小数',trigger:'blur'}],
        fastPriceFloat: [{ required: true, message: '请输入快速购票浮动价', trigger: 'blur' },{pattern:reg,message:'请输入-50~50，最多支持输入两位小数',trigger:'blur'}],
      },
      dialogVisible:false,
      title:'新增浮动价格设置',
      getLoading:false,
      loading:false,
      form:{
        cityIdList:[],
        floatUnit:1,
        initPriceFloat:'',
        discountPriceFloat:'',
        fastPriceFloat:'',
      },
      cityListOptions:[],
      defaultCityList:[],
      row:null,
      disabledCityIdList:[],
      defaultCityListId:[], //全部id
      lastCityIdList:[],
    }
  },
  computed: {
    objectTypeText() {
      return this.form.floatUnit ? '%' : '元'
    }
  },
  watch: {
  },
  methods: {
    changeRadio(e) {
      this.form.initPriceFloat = ''
      this.form.discountPriceFloat = ''
      this.form.fastPriceFloat = ''
    },
    handleInput(item,key) {
      // const val = this.formatNumber(item)
      // console.log(item, 'item========handleInput', key)
      // this.form[key] = val
      // this.$set(this.list[index], key, val)
    },
    handleChange(value) {
      // console.log(value, 'value========handleChange',this.lastCityIdList)
      let arr = deepClone(value)
      if(this.cityListOptions[0].disabled) {
        this.lastCityIdList = arr
        return
      }
      if(arr[0] === 'All' && this.lastCityIdList.includes('All') && (this.defaultCityListId.length > arr.length - 1)) {
        // console.log('全选====子集取消了')
        // 去掉数组第一个
        this.$set(this.form, 'cityIdList',arr.slice(1))
        this.lastCityIdList = deepClone(arr.slice(1))
        return;
      }
      if(arr.includes('All') && !this.lastCityIdList.includes('All')) {
        // console.log('全选====')
        this.form.cityIdList = ['All',...this.defaultCityListId]
        this.lastCityIdList = deepClone(this.form.cityIdList)
        return
      }
      if(this.lastCityIdList.includes('All') && arr[0] !== 'All') {
        // console.log('全选====取消')
        this.form.cityIdList = []
        this.lastCityIdList = this.form.cityIdList
        return;
      }
      if(arr[0] !== 'All' && arr.length === this.defaultCityListId.length) {
        this.form.cityIdList = ['All',...arr]
        this.lastCityIdList = deepClone(this.form.cityIdList)
        return;
      }

        this.lastCityIdList = arr


      // let a = this.$refs.cascaderRef.getCheckedNodes()
      // console.log(a,'aaaaaa')
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if(!(Number(this.form.initPriceFloat) >= Number(this.form.fastPriceFloat) && Number(this.form.fastPriceFloat) > Number(this.form.discountPriceFloat))) {
            this.$message.error('填写时，市场价浮动应大于等于快速购票浮动，且特惠购票浮动应小于快速购票浮动')
            return
          }
          this.loading = true
          let cityNameList = []
          this.defaultCityList.forEach(item => {
            if(item.children && item.children.length) {
              item.children.forEach(items => {
                if(this.form.cityIdList.includes(items.value)) {
                  cityNameList.push(item.label + '/' +items.label)
                }
              })
            }
          })
          let cityIdList = this.form.cityIdList.filter(item => item !== 'All')
          console.log(cityIdList.length,'cityIdList.length',cityIdList)
          // return
          if(this.row) {
            const res = await MiniModel.priceFloatSettingUpdate({
              ...this.form,
              cityIdList:cityIdList,
              id:this.row.id,
              appKey: localStorage.getItem('appKeyMini'),
              cityNameList:cityNameList,
            })
            this.loading = false
            if(res.data.code !== 200) {
              this.$message.error(res.data.message)
              return
            }
            this.$message.success(res.data.message)
            this.$emit('refresh')
            this.handelClosed()
          }else{
            const res = await MiniModel.priceFloatSettingAdd({
              ...this.form,
              cityIdList:cityIdList,
              appKey: localStorage.getItem('appKeyMini'),
              cityNameList:cityNameList,
            })
            console.log(res,'新增====')
            this.loading = false
            if(res.data.code !== 200) {
              this.$message.error(res.data.message)
              return
            }
            this.$message.success(res.data.message)
            this.$emit('refresh')
            this.handelClosed()
          }
        } else {
          // this.$message.error('请填写完整信息')
          return
        }
      })
      // this.loading = true
    },
    reset() {
      this.form = {
        cityIdList:[],
        floatUnit:1,
        initPriceFloat:'',
        discountPriceFloat:'',
        fastPriceFloat:'',
      }
      this.row = null
      // this.cityListOptions = []
      this.defaultCityList = []
      this.disabledCityIdList = []
      this.defaultCityListId = []
      this.lastCityIdList = []
    },
    async handleOpen(type,row,cityIdList) {
      console.log(row,'row=====',type,cityIdList)
      this.dialogVisible = true
      this.getLoading = true
      this.reset()
      if(type === 0) {
        this.title = '新增浮动价格设置'
      }else if(type === 1) {
        this.title = '编辑浮动价格设置'
        this.row = deepClone(row)
        this.form = deepClone(row)
      }
      await this.getCity(cityIdList)
      // TODO 禁用其他城市下拉
      this.getLoading = false
    },
    handelClosed() {
      this.dialogVisible = false
    },
    async getCity(cityIdList) {
      const res = await MiniModel.provinceCity()
      if(res.data.code !== 200) {
        this.$message.error(res.msg)
        return
      }
      if(res.data.code == 200) {
        this.defaultCityList = res.data.data
        let length = 0
        res.data.data.forEach(item => {
          if(item.children && item.children.length) {
            length += item.children.length
            item.children.forEach(child => {
              this.defaultCityListId.push(child.value)
            })
          }
        })
        let arr = this.defaultCityList.map(item => {
          if(item.children && item.children.length) {
            item.children.map(child => {
              // console.log(child,'childchild',typeof child.value)
              if(cityIdList.includes(String(child.value))) {
                child.disabled = true
              }else{
                child.disabled = false
              }
              return child
            })
            let newArr = item.children.filter(a => {
              return a.disabled
            })
            if(item.children.length !==0 &&item.children.length === newArr.length) {
              item.disabled = true
            }
            return item
          }else{
            return item
          }
        })
        arr.unshift({
          label:'全部',
          value:'All',
          // children: null,
          disabled: cityIdList.length > 0,
          // children:[],
        })
        this.cityListOptions = arr
        if(this.defaultCityListId.length === this.form.cityIdList.length) {
          this.form.cityIdList = ['All',...this.form.cityIdList]
        }
        // localStorage.setItem('cityListSet',JSON.stringify(res.data.data))
      }
    },
    formatNumber(value) {
      // 只允许数字和小数点
      value = value.replace(/[^\d.]/g, '');

      // 如果首位是小数点，自动补0
      if (value.startsWith('.')) {
        value = '0' + value;
      }

      // 限制最多两位小数
      if (value.includes('.')) {
        const parts = value.split('.');
        parts[1] = parts[1].slice(0, 2); // 保留最多两位小数
        value = parts.join('.');
      }

      // 限制输入范围在 0.00 到 10.00 之间
      if (parseFloat(value) < -50) {
        value = '-50.00';
      }
      if (parseFloat(value) > 50) {
        value = '50.00';
      }
      return value
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #333 !important;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/set/priceFloat/priceFloatPop.vue